export default __webpack_public_path__ + "static/media/sports.dfce12d8.png";